module.exports = __webpack_public_path__ + "img/identification.b8751099.webp";